'use client';

import dynamic from 'next/dynamic';

export const GlobalPopupControllerMount = dynamic(
  () =>
    import('./GlobalPopupController').then(
      ({ GlobalPopupController }) => GlobalPopupController,
    ),
  { ssr: false },
);
